import React from 'react'

function BarChartTooltip({ active, payload }) {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-white p-4 border border-gray-200 rounded-lg shadow-lg max-w-xs">
          <p className="font-semibold text-gray-800">{data.name}</p>
          <p className="text-sm text-blue-600 mb-1">
            Importance: {(data.importance * 100).toFixed(1)}%
          </p>
          <p className="text-sm text-green-600 mb-2">
            Net Priority: {data.net_priority.toFixed(1)}
          </p>
        </div>
      );
    }
    return null;
}

export default BarChartTooltip
